var headingFontWeight = 'bold';
export default (context => ({
  font: {
    headingFontFamily: '"Proxima Nova", sans-serif',
    bodyFontFamily: '"Source Sans Pro", sans-serif',
    accentFontFamily: '"Source Sans Pro", sans-serif',
    boldHeadingFontFamily: '"Proxima Nova Bold", sans-serif',
    headingFontWeight,
    h1FontSize: '36px',
    h1FontWeight: 'normal',
    h1LineHeight: '44px',
    h1MobileFontSize: '30px',
    h1MobileLineHeight: '33px',
    h2FontSize: '28px',
    h2FontWeight: 'normal',
    h2LineHeight: '32px',
    h2MobileFontSize: '26px',
    h2MobileLineHeight: '30px',
    h3FontSize: '22px',
    h3FontWeight: 'normal',
    h3LineHeight: '28px',
    h3MobileFontSize: '23px',
    h3MobileLineHeight: '27px',
    h4FontSize: '18px',
    h4FontWeight: headingFontWeight,
    h4LineHeight: '22px',
    h4MobileFontSize: '20px',
    h4MobileLineHeight: '24px',
    h5FontSize: '16px',
    h5FontWeight: headingFontWeight,
    h5LineHeight: '16px',
    h5MobileFontSize: '18px',
    h5MobileLineHeight: '24px',
    h6FontWeight: headingFontWeight,
    h6FontSize: '16px',
    h6LineHeight: '16px',
    h6MobileFontSize: '16px',
    h6MobileLineHeight: '16px',
    baseFontSize: '16px',
    baseLineHeight: '24px',
    baseMobileFontSize: '16px',
    baseMobileLineHeight: '21px',
    smallFontSize: '14px',
    smallLineHeight: '20px',
    smallMobileFontSize: '14px',
    smallMobileLineHeight: '20px',
    xsmallFontSize: '14px',
    xsmallLineHeight: '20px',
    xsmallMobileFontSize: '14px',
    xsmallMobileLineHeight: '20px',
    accentLargeFontSize: '38px',
    accentLargeLineHeight: '42px',
    accentLargeMobileFontSize: '26px',
    accentLargeMobileLineHeight: '30px',
    accentMediumFontSize: '24px',
    accentMediumLineHeight: '30px',
    accentMediumMobileFontSize: '20px',
    accentMediumMobileLineHeight: '27px'
  },
  colour: {
    text: context.colour.neutral800,
    textLight: context.colour.neutral500,
    textDark: context.colour.neutral900,
    heading: context.colour.neutral700,
    link: context.colour.allhomesRed700,
    linkHover: context.colour.allhomesRed700,
    linkVisited: context.colour.allhomesRed700
  }
}));